import axios from 'axios'
import { API } from 'src/common/api-service/API'
import { getAxiosOptionsURL } from 'src/common/functions'

const axiosOptions = getAxiosOptionsURL()

export let ApiServiceMain
export default ({ app }) => {
  let instance = new API(axios.create(axiosOptions))

  ApiServiceMain = instance
  app.config.globalProperties.$axios = instance
}
